import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/servicelist/[serviceId]/freelancers/page.jsx");
